"use client";

import FAQSection from "@/components/FAQ/FAQSection";

import { singularSpecifications } from "./Sliders/singularSpecifications";
import VadImage from "vadimages-nextjs-image-optimizer";

const specifications = singularSpecifications.map((spec, specIdx) => {
  const cardImageName = spec.title
    .replaceAll(":", "")
    .replaceAll(" ", "-")
    .toLowerCase();

  const nodeBlock = (
    <div className="md:grid grid-cols-2">
      <div className="mx-auto max-w-[224px] max-h-[355px] mb-4 p-6">
        <VadImage
          src={`/images/singular/specifications/${cardImageName}.png`}
          alt=""
          width={448}
          height={330}
        />
      </div>
      <div>
        {Object.entries(spec.specs).map(([_, currSpec]) => (
          <div key={`spec-block-${currSpec.label}`} className="py-1.5">
            <p className="font-medium">{currSpec.label}</p>
            <ul className="space-y-1">
              {currSpec.keyPoints.map((l: string, lIdx: number) => (
                <li
                  className="relative translate-x-[1.25rem] max-w-[calc(100vw-1.25rem-48px)] before:content-[''] before:absolute before:w-2 before:h-2 before:bg-golden-lemon before:top-2 before:-left-4 [&>ul]:list-disc [&>ul]:translate-x-[1.25rem]"
                  key={`${lIdx}`}
                  dangerouslySetInnerHTML={{ __html: l }}
                />
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  );

  return {
    order: specIdx + 1,
    question: spec.title,
    answer: "",
    additionalNode: nodeBlock,
  };
});

export const MobileSingularSpecifications = () => {
  return <FAQSection containerClassName="px-6" questions={specifications} />;
};
